import { useCallback, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { trackEvent } from '@monofront/tracking';

type SelectItemEventData = {
  product: {
    sku: string;
    name: string;
    index: number;
  };
};

type RecommendationTrackingArgs = {
  trackingId: string;
};

type RecommendationTrackingReturn = {
  sendSelectItemEvent: (eventData: SelectItemEventData) => void;
};

export const useRecommendationTracking = ({
  trackingId,
}: RecommendationTrackingArgs): RecommendationTrackingReturn => {
  const impressionIdRef = useRef(uuid());

  const sendSelectItemEvent = useCallback(
    (eventData: SelectItemEventData) => {
      trackEvent({
        type: 'LFSelectItem',
        data: {
          item_list_id: trackingId,
          item_list_impression_id: impressionIdRef.current,
          selected_item: {
            item_id: eventData.product.sku,
            item_name: eventData.product.name,
            index: eventData.product.index,
          },
        },
      });
    },
    [trackingId],
  );

  return { sendSelectItemEvent };
};
